import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { NgbModalRef, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PdfUtils } from 'src/app/shared/utils/pdf-utils';
import { KmlUtils } from 'src/app/shared/utils/kml-utils';
import { PptxUtils } from 'src/app/shared/utils/pptx-utils';
import { AppMovilService } from 'src/app/services/app-movil.service';
import { MapUtils } from 'src/app/shared/utils/map-utils';
import { take } from 'rxjs/operators';
import { ObraDTO } from 'src/app/models/dtos/obra-dto';

@Component({
  selector: 'modal-ficha-elementos',
  templateUrl: './modal-ficha-elementos.component.html',
  styleUrls: ['./modal-ficha-elementos.component.scss']
})
export class ModalFichaElementosComponent implements OnInit {

  public obraSeleccionada: ObraDTO;
  public distanciasElementos: any[] = [];

  @ViewChild('modalFichaElementos')
  public modalFichaElementos: any;

  public modalActivo: NgbModalRef;

  @Input('mostrarBtnGuardarFormato')
  public mostrarBtnGuardarFormato: boolean = false;

  @Output()
  // public guardarFormatoListener: EventEmitter<FichaTecnica> = new EventEmitter<FichaTecnica>();

  // public polylinesCUS: GooglePolyline[] = null;
  // public polylinesDV: GooglePolyline[] = null;
  // public polylinesMIA: GooglePolyline[] = null;
  // public polylinesORI: GooglePolyline[] = null;
  // public polylinesPE: GooglePolyline[] = null;
  // public polylinesSHCP: GooglePolyline[] = null;

  public distanciaFinalSHCPVerde: any = 0;
  public distanciaFinalSHCPRojo: any = 0;
  public distanciaFinalSHCPAmarillo: any = 0;
  public distanciaFinalPEVerde: any = 0;
  public distanciaFinalPERojo: any = 0;
  public distanciaFinalPEAmarillo: any = 0;
  public distanciaFinalORIVerde: any = 0;
  public distanciaFinalORIRojo: any = 0;
  public distanciaFinalORIAmarillo: any = 0;
  public distanciaFinalDVVerde: any = 0;
  public distanciaFinalDVRojo: any = 0;
  public distanciaFinalDVAmarillo: any = 0;
  public distanciaFinalMIAVerde: any = 0;
  public distanciaFinalMIARojo: any = 0;
  public distanciaFinalMIAAmarillo: any = 0;
  public distanciaFinalCUSVerde: any = 0;
  public distanciaFinalCUSRojo: any = 0;
  public distanciaFinalCUSAmarillo: any = 0;

  constructor(
    private modalService: NgbModal,
    private pdfUtils: PdfUtils,
    private kmlUtils: KmlUtils,
    private pptxUtils: PptxUtils,
    private appMovilService: AppMovilService,
    private mapUtils: MapUtils
  ) { }

  public ngOnInit(): void {
  }

  public async abrirModal(obra: ObraDTO): Promise<any> {
    this.obraSeleccionada = obra;
    let capas: string[] = ["SHCP", "PE", "MIA", "DV", "CUS"];
    try {
      for (let indice = 0; indice < capas.length; indice++) {
        // let polylineCapa: GooglePolyline[] = await this.appMovilService.obtenerPolylinePorCapaPlaneacion('appPlaneacion', obra.nombreEstado, obra.nombreObra, obra.nombreTramoLicitacion, null, capas[indice]).pipe(take(1)).toPromise();
        // let distanciaCapa: any = await this.mapUtils.calcularDistanciaDePolylinePorColor(polylineCapa, capas[indice]);
        // this.distanciasElementos.push(parseFloat((distanciaCapa.distanciaVerde / 1000).toFixed(2)), parseFloat((distanciaCapa.distanciaAmarillo / 1000).toFixed(2)), parseFloat((distanciaCapa.distanciaRojo / 1000).toFixed(2)));
      }
      let acumulado: number = this.distanciasElementos.reduce((acc: number, curr: number) => acc + curr, 0);
      this.distanciasElementos.push(parseFloat(acumulado.toFixed(2)));
      this.modalActivo = this.modalService.open(this.modalFichaElementos, { centered: true, size: 'lg', windowClass: 'modal-ficha-tecnica' });
    } catch (err) {
      console.error(err);
    }
  }


  public descargar(): void {
    this.pdfUtils.descargarFichaSinImagenes();
  }

  // public descargarKml(): void {
  //   this.kmlUtils.descargarKml(this.fichaTecnica.googleMap.googlePolyline);
  // }

  // public descargarPowerPoint() {
  //   this.pptxUtils.descargarPowerPointFichaTecnica(this.fichaTecnica);
  // }

  public cerrarModal(): void {
    this.modalActivo.close();
  }

}